import { useRouter as useBaseRouter, usePathname } from "next/navigation";
import NProgress from "nprogress";
import { useEffect } from "react";
export function useRouter() {
  const router = useBaseRouter();
  const pathname = usePathname();
  // const searchParams = useSearchParams(); // cause csr bailout error

  // Stop NProgress when route changes
  useEffect(() => {
    NProgress.done();
  }, [pathname]);
  const {
    push,
    replace,
    back,
    forward,
    refresh,
    prefetch
  } = router;

  // Intercept push method
  router.push = async (...args: Parameters<typeof push>) => {
    NProgress.start();
    return push(...args);
  };

  // Intercept replace method
  router.replace = async (...args_0: Parameters<typeof replace>) => {
    NProgress.start();
    return replace(...args_0);
  };

  // Keep other methods unchanged
  router.back = back;
  router.forward = forward;
  router.refresh = refresh;
  router.prefetch = prefetch;
  return router;
}